import { motion } from 'motion/react';

const VELKO_PATH =
  'M14 10 L17 6 L20 10 L23 6 L26 10 L29 6 L32 10 L35 6 L38 10 L41 6 L44 10 L47 6 L50 10 L50 52 L47 58 L44 52 L41 58 L38 52 L35 58 L32 52 L29 58 L26 52 L23 58 L20 52 L17 58 L14 52 Z';

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Auth-bootstrap loader displayed by route guards while the auth context
 * resolves the current user. Light-first, dark-aware, brand-rhymed with
 * `VelkoSplash` so the transition into the layout feels seamless.
 */
export function BootSplash() {
  const reduced = prefersReducedMotion();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Chargement"
      className="flex min-h-screen w-full flex-col items-center justify-center gap-5 bg-[#F7F7F8] px-6 dark:bg-background"
    >
      <motion.svg
        viewBox="0 0 64 64"
        className="size-12 text-charcoal-950 dark:text-white"
        initial={reduced ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: reduced ? 0 : 0.3, ease: [0.16, 1, 0.3, 1] }}
        aria-hidden="true"
      >
        <path d={VELKO_PATH} fill="currentColor" />
        <rect x={19} y={22} width={26} height={6} rx={1.5} fill="#A3E635" />
      </motion.svg>
      <div
        className="relative h-[3px] w-28 overflow-hidden rounded-full bg-slate-200 dark:bg-charcoal-700"
        aria-hidden="true"
      >
        {!reduced && (
          <motion.span
            className="absolute inset-y-0 left-0 block w-1/3 rounded-full bg-charcoal-900 dark:bg-white"
            initial={{ x: '-110%' }}
            animate={{ x: '320%' }}
            transition={{ duration: 1.2, ease: 'easeInOut', repeat: Infinity }}
          />
        )}
      </div>
    </div>
  );
}
